const blues = {
  1: { main: '#223245', font: '#000000' },
};

export default blues;
